import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { map, first, flatMap } from 'rxjs/operators';

import { ACResourceService } from '@appcatalyst/ng-cms-core-lib';

@Injectable({
  providedIn: 'root'
})
export class SourceService {

  private source = new ReplaySubject<any>(1);

  constructor(private cms: ACResourceService) {
  }

  public updateSource = (id: string) => {
    var path = `/source/${id}`
    return this.cms.request('GET', path).pipe(
      first(),
      map(body => {
        this.source.next(body.data)
        return body.data
      })
    )
  }

  public getSource = (): Observable<any> => {
    return this.source.asObservable()
  }

  public createSource = (data: any) => {
    var path = '/sources'
    return this.cms.request('POST', path, null, data).pipe(
      first(),
      map(body => {
        this.source.next(body.data);
        return body.data
      })
    )
  }

  public saveSource = (data: any) => {
    var path = '/source/'+data.id
    return this.cms.request('PUT', path, null, data).pipe(
      first(),
      map(body => {
        this.source.next(body.data);
        return body.data
      })
    )
  }

  public synchronizeSource = () => {
    return this.getSource().pipe(
      first(),
      flatMap(source => {
        var path = '/source/'+source.id
        source.last_pull = 1
        source.last_push = 1
        source.last_pull_start = 0
        source.last_push_start = 0
        return this.cms.request('PUT', path, null, source).pipe(
          first(),
          map(body => {
            this.source.next(body.data);
            return body.data
          })
        )
      })
    )
    
  }

  public setActive = (active: boolean) => {
    return this.getSource().pipe(
      first(),
      flatMap(source => {
        var path = '/source/'+source.id
        source.active = active
        return this.cms.request('PUT', path, null, source).pipe(
          first(),
          map(body => {
            this.source.next(body.data);
            return body.data
          })
        )
      })
    )
    
  }
}
